import React from 'react'

import './Loading.css'

function Loading() {

    


    return (
        <div className="loadingContainer">
            <div className="loading">
                <span className="load load-1"></span>
                <span className="load load-2"></span>
                <span className="load load-3"></span>
                <span className="load load-4"></span>
                <span className="load load-5"></span>
                <span className="load load-6"></span>
                <span className="load load-7"></span>
                <span className="load load-8"></span>
            </div>
        </div>

    )
}

export default Loading
